import { Module } from 'vuex'

import { BookmarkUseCase } from '@/application/bookmark/bookmarkUseCase'
import { BookmarkRepository } from '@/domain/repositories/bookmark/bookmarkRepository'
import { Bookmark } from '@/domain/value_objects/bookmark/bookmark'

interface BookmarkState {
  bookmark: Bookmark
  isLoading: boolean
  error: string | null
}

export const bookmarkModule = (repository: BookmarkRepository): Module<BookmarkState, any> => {
  const bookmarkUseCase = new BookmarkUseCase(repository)

  return {
    namespaced: true,
    state: {
      bookmark: {
        progress: 0,
        numberOfProblems: 0,
        numberOfSolved: 0,
        problems: []
      },
      isLoading: false,
      error: null
    },
    mutations: {
      setBookmark(state, bookmark: Bookmark) {
        state.bookmark = bookmark
      },
      setIsLoading(state, isLoading: boolean) {
        state.isLoading = isLoading
      },
      setError(state, error: string | null) {
        state.error = error
      }
    },
    actions: {
      async getBookmark({ commit }, { userId }: { userId: string }) {
        commit('setIsLoading', true)
        commit('setError', null)
        try {
          const res = await bookmarkUseCase.getBookmark(userId)
          commit('setBookmark', res)
        } catch (e) {
          commit('setError', e)
        } finally {
          commit('setIsLoading', false)
        }
      },
      async postBookmark({ commit }, { problemId, userId }: { problemId: string; userId: string }) {
        commit('setIsLoading', true)
        commit('setError', null)
        try {
          await bookmarkUseCase.postBookmark(problemId, userId)
        } catch (e) {
          commit('setError', e)
        } finally {
          commit('setIsLoading', false)
        }
      },
      async deleteBookmark({ commit }, { problemId, userId }: { problemId: string; userId: string }) {
        commit('setIsLoading', true)
        commit('setError', null)
        try {
          await bookmarkUseCase.deleteBookmark(problemId, userId)
        } catch (e) {
          commit('setError', e)
        } finally {
          commit('setIsLoading', false)
        }
      }
    },
    getters: {
      bookmark: state => state.bookmark,
      isLoading: state => state.isLoading,
      error: state => state.error
    }
  }
}
